"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _marker = _interopRequireDefault(require("../../assets/icons/marker.svg"));

var _x = _interopRequireDefault(require("../../assets/icons/x.svg"));

var _searchField = _interopRequireDefault(require("../search-field"));

var _reactIntl = require("react-intl");

var _intlFormat = require("../../lib/intl-format");

var _translations = _interopRequireDefault(require("./translations"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SearchPanel,
    boundMethodCheck = function boundMethodCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new Error('Bound instance method accessed before binding');
  }
};

var _default = (0, _intlFormat.withTranslations)(_translations.default, SearchPanel = function () {
  var SearchPanel =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(SearchPanel, _React$Component);

    function SearchPanel() {
      var _this;

      _classCallCheck(this, SearchPanel);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(SearchPanel).apply(this, arguments));
      _this.onClose = _this.onClose.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(SearchPanel, [{
      key: "onClose",
      value: function onClose() {
        boundMethodCheck(this, SearchPanel);
        return this.props.onClose();
      }
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(newProps) {
        return this.setState(_objectSpread({}, newProps));
      }
    }, {
      key: "render",
      value: function render() {
        var location_placeholder, search_placeholder;
        search_placeholder = this.props.intl.formatMessage({
          id: 'library.navbar.search_for_events',
          defaultMessage: 'Search for events'
        });
        location_placeholder = this.props.intl.formatMessage({
          id: 'library.navbar.enter_location',
          defaultMessage: 'Enter location'
        });
        return _react.default.createElement("div", {
          className: "SearchPanel"
        }, _react.default.createElement("div", {
          className: (0, _classnames.default)('overlay', {
            open: this.props.open
          }),
          onClick: this.onClose
        }), _react.default.createElement("div", {
          className: (0, _classnames.default)('panel', {
            open: this.props.open
          })
        }, _react.default.createElement("header", null, _react.default.createElement(_x.default, {
          className: "close-button",
          onClick: this.onClose
        })), _react.default.createElement("div", {
          className: "searchFields"
        }, _react.default.createElement(_searchField.default, {
          onChange: this.props.onSearch,
          value: this.props.search,
          placeholder: search_placeholder
        }), false ? _react.default.createElement("div", {
          className: "searchLocation"
        }, _react.default.createElement("input", {
          type: "input",
          defaultValue: "Toronto, ON",
          placeholder: location_placeholder
        }), _react.default.createElement(_marker.default, {
          className: "input-icon-left"
        })) : void 0)));
      }
    }]);

    return SearchPanel;
  }(_react.default.Component);

  ;
  SearchPanel.propTypes = {
    open: _propTypes.default.bool,
    search: _propTypes.default.string,
    onSearch: _propTypes.default.func.isRequired,
    onClose: _propTypes.default.func.isRequired
  };
  SearchPanel.defaultProps = {
    open: false,
    search: ''
  };
  return SearchPanel;
}.call(void 0));

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/navbar/search-panel.js
// module id = 1464
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16